export default __webpack_public_path__ + "img/ellipsis-h.9aee8490.svg";